/**
 * Created by mgoria on 6/30/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthException = undefined;

var _Exception2 = require('./Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Thrown when auth error occurs
 */
let AuthException = exports.AuthException = function (_Exception) {
  _inherits(AuthException, _Exception);

  /**
   * @param {Object} error
   */
  function AuthException(error) {
    _classCallCheck(this, AuthException);

    return _possibleConstructorReturn(this, (AuthException.__proto__ || Object.getPrototypeOf(AuthException)).call(this, `Error on authentication. ${error}`));
  }

  return AuthException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-security/lib.compiled/Exception/AuthException.js
// module id = 434
// module chunks = 0